import gql from 'graphql-tag'

export const ADD_USER_ROLE = gql`
  mutation (
    $schoolId: Int!
    $personalProfileId: Int!
    $targetPersonalProfileId: Int!
    $roleId: Int!
    $startDate: Date!
    $endDate: Date
  ) {
    academyAddUserRole(
      schoolId: $schoolId
      personalProfileId: $personalProfileId
      targetPersonalProfileId: $targetPersonalProfileId
      roleId: $roleId
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      startDate
      endDate
      personalProfileId
      role {
        name
        permissions
      }
    }
  }
`

export const CHANGE_USER_ROLE = gql`
  mutation (
    $schoolId: Int!
    $personalProfileId: Int!
    $targetPersonalProfileId: Int!
    $roleId: Int!
    $userRoleId: Int!
    $startDate: Date!
    $endDate: Date
  ) {
    academyChangeUserRole(
      schoolId: $schoolId
      personalProfileId: $personalProfileId
      targetPersonalProfileId: $targetPersonalProfileId
      roleId: $roleId
      userRoleId: $userRoleId
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      startDate
      endDate
      personalProfileId
      role {
        name
      }
    }
  }
`

export const REMOVE_USER_ROLE = gql`
  mutation ($schoolId: Int!, $personalProfileId: Int!, $targetPersonalProfileId: Int!, $roleId: Int!) {
    academyRemoveUserRole(
      schoolId: $schoolId
      personalProfileId: $personalProfileId
      targetPersonalProfileId: $targetPersonalProfileId
      userRoleId: $roleId
    ) {
      id
      startDate
      endDate
      personalProfileId

      role {
        name
        id
      }
    }
  }
`
